import { ArrowUpDown, TrendingUp } from 'lucide-react';
import React from 'react'


interface ActivityItemProps {
  date: string;
  message: string;
}

const ActivityItem: React.FC<ActivityItemProps> = ({ date, message }) => (
  <div className="flex gap-3 py-3 border-b border-gray-100 last:border-0">
    <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center flex-shrink-0">
      <ArrowUpDown className="w-4 h-4 text-primary" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-xs text-gray-500 mb-1">{date}</p>
      <p className="text-sm text-gray-900">{message}</p>
    </div>
  </div>
);


export default ActivityItem